import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import swal from 'sweetalert';
import Select from 'react-select';
import {
    useGetSystemtimesForRoutesQuery
} from '../../Features/timeSlice';
import {
    useCompleteUserRouteSetupMutation,
    useDeleteClientRouteMutation,
    useEditUserRouteMutation,
    useGetUserRouteInfoQuery
} from '../../Features/clientsRoutesSlice';
import { selectCurrentUser } from '../../Features/auth/authSlice';
import { useSelector } from 'react-redux';
import LoadingBar from 'react-top-loading-bar';
import { useIsOnline } from 'react-use-is-online';
import { useGetUserCategoriesForRoutesQuery } from '../../Features/categories';
import { useGetUserTaxesQuery } from '../../Features/taxesSlice';
import { useGetUserSeatingProfileByUserIdQuery } from '../../Features/seatsSlice';
import { useGetUserVehiclesForRoutesQuery } from '../../Features/userVehicles';
import { useGetUserActiveDiscountQuery } from '../../Features/discountsSlice';

import {
    MapIcon,
    TagIcon,
    ClockIcon,
    CurrencyDollarIcon,
    AdjustmentsIcon,
    ReceiptTaxIcon,
    TruckIcon,
    CheckCircleIcon,
    SaveIcon,
    ArrowLeftIcon,
    PencilIcon,
    UserGroupIcon,
    InformationCircleIcon
} from '@heroicons/react/outline';

function RouteEditView() {
    const navigate = useNavigate();
    const { route_id, user_route_id } = useParams();

    const user = useSelector(selectCurrentUser);

    const [timeArray, setTime] = useState([]);
    const [clientTime, setClientTime] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [userRouteCurrentTime, setUserRouteCurrentTime] = useState(false);
    const [userRouteCurrentTaxes, setUserRouteCurrentTaxes] = useState(false);
    const [progress, setProgress] = useState(0);
    const [timeSeatingArr, setTimeSeatingArr] = useState({});
    const [timeVerhicle, setTimeVerhicle] = useState({});
    const [existingRouteTaxes, setExistingRouteTaxes] = useState({});
    const { isOnline } = useIsOnline();

    const [input, setInput] = useState({
        period: '',
        category_id: '',
        discount_id: '',
        price: '',
        cost: '',
        status: '',
        apply_discount: '',
        editable_price: '',
        route_id: '',
    });

    const [taxesInput, setTaxesInput] = useState({
        route_tax: [],
    });

    const [errors, setErrors] = useState({
        period: '',
        category: '',
        discount: '',
        price: '',
        cost: '',
        status: '',
        route_id: '',
        editable_price: '',
        barcode: '',
        route_tax: '',
        route_time: ''
    });

    const handleChange = (e) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value
        });
    };

    const handleTimeSeatingArrChange = (e) => {
        setTimeSeatingArr({
            ...timeSeatingArr,
            [e.target.name]: e.target.value
        });
    };

    const handleTimeVerhicleChange = (e) => {
        setTimeVerhicle({
            ...timeVerhicle,
            [e.target.name]: e.target.value
        });
    };

    const {
        data: clientCategories,
        isLoading: isLoadingClientCategories,
        isSuccess: isSuccessClientCategories,
    } = useGetUserCategoriesForRoutesQuery({
        user_id: user.id
    });

    const {
        data: userDiscounts,
        isSuccess: isSuccessUserDiscounts,
    } = useGetUserActiveDiscountQuery(user.id);

    const {
        data: userRoute,
        isLoading: userRouteIsLoading,
        isSuccess: isSuccessUserRoute,
        refetch
    } = useGetUserRouteInfoQuery({
        user_id: user.id,
        route_id: user_route_id
    });

    const {
        data: time,
        isLoading,
        isSuccess,
    } = useGetSystemtimesForRoutesQuery();

    const {
        data: taxes,
        isLoading: isLoadingTaxes,
        isSuccess: isSuccessTaxes,
    } = useGetUserTaxesQuery({
        user_id: user.id
    });

    const {
        data: seatingProfiles,
        isSuccess: isSuccessSeatingProfiles,
    } = useGetUserSeatingProfileByUserIdQuery({
        user_id: user.id
    });

    const {
        data: userVehicles,
        isSuccess: isSuccessUserVerhicles,
    } = useGetUserVehiclesForRoutesQuery({
        user_id: user.id
    });

    useEffect(() => {
        setProgress(20);

        if (isLoading) {
            setProgress(40);
        }

        if (isSuccessUserRoute && userRoute?.data) {
            userRoute.data.map(data => (
                data.user_route_details
                    ? setInput({
                        ...input,
                        start_off_station_name:
                            data.user_route_details.start_off_station_name,
                        destination_station_name:
                            data.user_route_details.destination_station_name,
                        price: data.user_route_details.price,
                        cost: data.user_route_details.cost,
                        status: data.user_route_details.status,
                        editable_price:
                            data.user_route_details.editable_price,
                        apply_discount:
                            data.user_route_details.apply_discount,
                        category_id:
                            data.user_route_details.category_id,
                        discount_id:
                            data.user_route_details.discount_id,
                        period:
                            data.user_route_details.period,
                        user_route_id:
                            data.user_route_details.user_route_id,
                        route_id:
                            data.user_route_details.route_id,
                        user_billing_id:
                            data.user_route_details.user_billing_id,
                    })
                    : null
            ));

            setProgress(50);

            userRoute.data.map(data => (
                data.user_route_details
                    ? setIsEdit(data.user_route_details.is_edit)
                    : null
            ));

            userRoute.data.map(data => (
                data.user_route_time
                    ? setClientTime(data.user_route_time)
                    : null
            ));

            setProgress(60);

            if (userRoute.data[2]) {
                setExistingRouteTaxes(
                    userRoute.data[2].user_route_taxes_id
                );

                setTaxesInput({
                    ...taxesInput,
                    route_tax: userRoute.data[2].user_route_taxes,
                });
            }

            setProgress(70);

            if (userRoute.data[1]) {
                const newValue = {};

                for (
                    let i = 0;
                    i < userRoute.data[1].user_route_time.length;
                    i++
                ) {
                    userRoute.data[1].user_route_time.map(data => (
                        newValue[
                            userRoute.data[1].user_route_time[i].value
                        ] =
                            userRoute.data[1].user_route_time[i]
                                .seating_profile_id
                    ));
                }

                setTimeSeatingArr(prevValues => ({
                    ...prevValues,
                    ...newValue
                }));
            }

            setProgress(80);

            if (userRoute.data[1]) {
                const newValue = {};

                for (
                    let i = 0;
                    i < userRoute.data[1].user_route_time.length;
                    i++
                ) {
                    userRoute.data[1].user_route_time.map(data => (
                        newValue[
                            userRoute.data[1].user_route_time[i].value
                        ] =
                            userRoute.data[1].user_route_time[i]
                                .vehicle_id
                    ));
                }

                setTimeVerhicle(prevValues => ({
                    ...prevValues,
                    ...newValue
                }));
            }

            setProgress(100);
        }

        return () => {};
    }, [userRoute, userVehicles]);

    const [completeUserRouteSetup] =
        useCompleteUserRouteSetupMutation();

    const [editUserRoute] =
        useEditUserRouteMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        setProgress(40);

        if (isEdit) {
            if (isSuccessUserRoute) {
                const data = {
                    price: input.price,
                    cost: input.cost,
                    category_id: input.category_id,
                    discount_id: input.discount_id,
                    period: input.period,
                    status: input.status,
                    editable_price: input.editable_price,
                    apply_discount: input.apply_discount,
                    route_id: input.user_route_id,
                    user_id: user.id,
                    user_billing_id: input.user_billing_id,
                    route_tax: taxesInput.route_tax,
                    route_time: timeArray,
                    user_route_current_taxes:
                        existingRouteTaxes
                            ? existingRouteTaxes
                            : false,
                    user_route_current_time:
                        clientTime
                            ? clientTime
                            : false,
                    route_time_seating_arr: timeSeatingArr,
                    route_time_verhicles: timeVerhicle,
                };

                setProgress(80);

                try {
                    const resp = await editUserRoute(data).unwrap();

                    swal(
                        'Success',
                        resp.message,
                        'success'
                    );

                    setProgress(100);
                    navigate(-1);
                } catch (err) {
                    setProgress(100);

                    if (err.data?.success === false) {
                        setErrors({
                            ...errors,
                            price: err.data.errors?.price,
                            route_time: err.data.errors?.route_time,
                            cost: err.data.errors?.cost,
                            period: err.data.errors?.period,
                        });

                        swal(
                            'Error',
                            err.data.error,
                            'error'
                        );
                    }
                }
            }
        } else {
            setProgress(40);

            const data = {
                price: input.price,
                cost: input.cost,
                category_id: input.category_id,
                discount_id: input.discount_id,
                user_billing_id: input.user_billing_id,
                period: input.period,
                route_id: input.route_id,
                user_id: user.id,
                user_route_id: input.user_route_id,
                route_time: timeArray,
                user_route_current_time:
                    userRouteCurrentTime
                        ? userRouteCurrentTime
                        : false
            };

            try {
                setProgress(80);

                await completeUserRouteSetup(data).unwrap();

                setProgress(100);
                refetch();
            } catch (err) {
                setProgress(100);

                if (err.data) {
                    setErrors({
                        ...errors,
                        price: err.data.errors?.price,
                        route_time: err.data.errors?.route_time,
                        cost: err.data.errors?.cost,
                        period: err.data.errors?.period,
                    });
                }
            }
        }
    };

    const [deleteClientRoute] =
        useDeleteClientRouteMutation();

    const handDeleteUser = async (e, client_route_id) => {
        if (
            window.confirm(
                'Are you sure you want to delete this route? This action cannot be reversed'
            )
        ) {
            try {
                const resp =
                    await deleteClientRoute({
                        client_route_id,
                        client_id: user.id
                    }).unwrap();

                swal(
                    'Success',
                    resp.message
                );

                navigate(-1);
            } catch (err) {
                swal(
                    'Error',
                    err.message,
                    'error'
                );
            }
        }
    };

    const editTime = () => {
        setUserRouteCurrentTime(clientTime);
        setIsEdit(false);
        setClientTime(false);
    };

    const handleTaxes = (e, id) => {
        const isChecked = e.target.checked;

        setTaxesInput(prevTaxes => {
            const updatedRouteTax = isChecked
                ? [...prevTaxes.route_tax, id]
                : prevTaxes.route_tax.filter(
                    taxId => taxId !== id
                );

            return {
                ...prevTaxes,
                route_tax: updatedRouteTax
            };
        });
    };

    const handleStatusChange = e => {
        const { checked } = e.target;

        setInput({
            ...input,
            [e.target.name]: checked ? 1 : 0
        });
    };

    const handleToggleEditablePrice = e => {
        const { checked } = e.target;

        setInput({
            ...input,
            [e.target.name]: checked ? 1 : 0
        });
    };

    const back = () => navigate(-1);

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '42px',
            borderRadius: '8px',
            borderColor: state.isFocused
                ? '#80b643'
                : '#d1d5db',
            boxShadow: state.isFocused
                ? '0 0 0 1px #80b643'
                : 'none',
            '&:hover': {
                borderColor: '#80b643'
            }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#80b643'
                : state.isFocused
                    ? '#f3f4f6'
                    : 'white',
            color: state.isSelected
                ? 'white'
                : '#374151'
        })
    };

    if (userRouteIsLoading) {
        return (
            <div className="w-full min-h-screen bg-gray-100 dark:bg-gray-950">
                <LoadingBar
                    color="#80b643"
                    height="4px"
                    progress={progress}
                    onLoaderFinished={() => setProgress(0)}
                />

                <div className="flex items-center justify-center min-h-[400px]">
                    <div className="text-center">
                        <div className="w-12 h-12 border-4 border-gray-200 border-t-[#80b643] rounded-full animate-spin mx-auto"></div>
                        <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
                            Loading route information...
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full min-h-screen bg-gray-100 dark:bg-gray-950 pb-12">
            <LoadingBar
                color="#80b643"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />

            {isSuccessUserRoute && (
                <div className="w-full max-w-6xl mx-auto px-3 sm:px-5 lg:px-6 pt-4 sm:pt-6">

                    {/* HEADER */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                        <div className="flex items-center gap-3">
                            <div className="w-11 h-11 rounded-xl bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                                <MapIcon className="w-6 h-6 text-[#80b643]" />
                            </div>

                            <div>
                                <h1 className="text-lg sm:text-xl font-semibold text-gray-800 dark:text-white">
                                    Route Setup
                                </h1>

                                <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                                    Configure route pricing, schedule, taxes and settings
                                </p>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={back}
                            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm font-medium text-gray-600 dark:text-gray-300 hover:border-[#80b643] hover:text-[#80b643] transition"
                        >
                            <ArrowLeftIcon className="w-4 h-4" />
                            Back
                        </button>
                    </div>

                    {/* ROUTE SUMMARY */}
                    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">
                        <div className="px-4 sm:px-5 py-4 border-b border-gray-200 dark:border-gray-800">
                            <div className="flex items-center gap-2">
                                <MapIcon className="w-5 h-5 text-[#80b643]" />

                                <div>
                                    <h2 className="text-sm sm:text-base font-semibold text-gray-800 dark:text-white">
                                        Route Information
                                    </h2>

                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                        Basic information for this route
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 sm:p-5 grid grid-cols-1 md:grid-cols-2 gap-5">

                            {/* ROUTE */}
                            <div>
                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                    Route
                                </label>

                                <div className="flex items-center gap-3 min-h-[42px] px-3 rounded-lg bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
                                    <MapIcon className="w-4 h-4 text-[#80b643] flex-shrink-0" />

                                    <span className="text-sm font-medium text-gray-700 dark:text-gray-200 truncate">
                                        {input.start_off_station_name} - {input.destination_station_name}
                                    </span>
                                </div>
                            </div>

                            {/* CATEGORY */}
                            <div>
                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                    Category
                                </label>

                                <select
                                    value={input.category_id}
                                    name="category_id"
                                    onChange={handleChange}
                                    className="w-full h-[42px] px-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                >
                                    <option value={false}>
                                        Select category
                                    </option>

                                    {isSuccessClientCategories &&
                                        clientCategories.data.map(data => (
                                            <option
                                                key={data.value}
                                                value={data.value}
                                            >
                                                {data.label}
                                            </option>
                                        ))}
                                </select>

                                {errors.category && (
                                    <p className="mt-1 text-xs text-red-500">
                                        {errors.category}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* PRICING */}
                    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">
                        <div className="px-4 sm:px-5 py-4 border-b border-gray-200 dark:border-gray-800">
                            <div className="flex items-center gap-2">
                                <CurrencyDollarIcon className="w-5 h-5 text-[#80b643]" />

                                <div>
                                    <h2 className="text-sm sm:text-base font-semibold text-gray-800 dark:text-white">
                                        Pricing & Discount
                                    </h2>

                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                        Configure the selling price and route cost
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 sm:p-5">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                                {/* PRICE */}
                                <div>
                                    <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                        Selling Price
                                    </label>

                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400">
                                            K
                                        </span>

                                        <input
                                            type="number"
                                            name="price"
                                            id="price"
                                            value={input.price}
                                            onChange={handleChange}
                                            className="w-full h-[42px] pl-8 pr-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                        />
                                    </div>

                                    {errors.price && (
                                        <p className="mt-1 text-xs text-red-500">
                                            {errors.price}
                                        </p>
                                    )}
                                </div>

                                {/* COST */}
                                <div>
                                    <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                        Cost
                                    </label>

                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400">
                                            K
                                        </span>

                                        <input
                                            type="number"
                                            name="cost"
                                            id="cost"
                                            value={input.cost}
                                            onChange={handleChange}
                                            className="w-full h-[42px] pl-8 pr-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                        />
                                    </div>

                                    {errors.cost && (
                                        <p className="mt-1 text-xs text-red-500">
                                            {errors.cost}
                                        </p>
                                    )}
                                </div>

                                {/* DISCOUNT */}
                                <div>
                                    <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                        Discount
                                    </label>

                                    <select
                                        value={input.discount_id}
                                        name="discount_id"
                                        onChange={handleChange}
                                        className="w-full h-[42px] px-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                    >
                                        <option value={false}>
                                            No discount
                                        </option>

                                        {isSuccessUserDiscounts &&
                                            userDiscounts.data.map(data => (
                                                <option
                                                    key={data.value}
                                                    value={data.value}
                                                >
                                                    {data.label}
                                                </option>
                                            ))}
                                    </select>

                                    {errors.discount && (
                                        <p className="mt-1 text-xs text-red-500">
                                            {errors.discount}
                                        </p>
                                    )}
                                </div>

                                {/* PERIOD */}
                                <div>
                                    <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                        Period
                                    </label>

                                    <div className="relative">
                                        <input
                                            type="number"
                                            name="period"
                                            id="period"
                                            value={input.period}
                                            onChange={handleChange}
                                            className="w-full h-[42px] px-3 pr-16 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                        />

                                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">
                                            days
                                        </span>
                                    </div>

                                    {errors.period && (
                                        <p className="mt-1 text-xs text-red-500">
                                            {errors.period}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* INITIAL TIME SETUP */}
                    {!clientTime && (
                        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">
                            <div className="px-4 sm:px-5 py-4 border-b border-gray-200 dark:border-gray-800">
                                <div className="flex items-center gap-2">
                                    <ClockIcon className="w-5 h-5 text-[#80b643]" />

                                    <div>
                                        <h2 className="text-sm sm:text-base font-semibold text-gray-800 dark:text-white">
                                            Route Schedule
                                        </h2>

                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                            Select the operating times for this route
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="p-4 sm:p-5">
                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                    Operating Times
                                </label>

                                <Select
                                    placeholder="Search and select times..."
                                    options={time}
                                    isSearchable
                                    isMulti
                                    onChange={setTime}
                                    styles={selectStyles}
                                />

                                {errors.route_time && (
                                    <p className="mt-1 text-xs text-red-500">
                                        {errors.route_time}
                                    </p>
                                )}

                                <div className="flex justify-end mt-5">
                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#80b643] hover:bg-[#719f3a] text-white text-sm font-medium shadow-sm transition"
                                    >
                                        Continue
                                        <ArrowLeftIcon className="w-4 h-4 rotate-180" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* SCHEDULE */}
                    {clientTime && isSuccessSeatingProfiles && (
                        <>
                            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">

                                <div className="px-4 sm:px-5 py-4 border-b border-gray-200 dark:border-gray-800">
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                                        <div className="flex items-center gap-2">
                                            <ClockIcon className="w-5 h-5 text-[#80b643]" />

                                            <div>
                                                <h2 className="text-sm sm:text-base font-semibold text-gray-800 dark:text-white">
                                                    Route Schedule
                                                </h2>

                                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                    Configure seats and vehicles for each departure time
                                                </p>
                                            </div>
                                        </div>

                                        <span className="inline-flex items-center self-start sm:self-auto px-2.5 py-1 rounded-full bg-[#80b643]/10 text-[#80b643] text-xs font-medium">
                                            {clientTime.length} time{clientTime.length !== 1 ? 's' : ''}
                                        </span>
                                    </div>
                                </div>

                                <div className="p-4 sm:p-5">
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                        {clientTime.map(data => (
                                            <div
                                                key={data.value}
                                                className="border border-gray-200 dark:border-gray-700 rounded-xl p-4 bg-gray-50/70 dark:bg-gray-800/50"
                                            >
                                                <div className="flex items-center gap-2 mb-4">
                                                    <div className="w-8 h-8 rounded-lg bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                                                        <ClockIcon className="w-4 h-4 text-[#80b643]" />
                                                    </div>

                                                    <div>
                                                        <p className="text-xs text-gray-500 dark:text-gray-400">
                                                            Departure
                                                        </p>

                                                        <p className="text-sm font-semibold text-gray-800 dark:text-white">
                                                            {data.label}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                                                    {/* SEATING */}
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                                            Seating Profile
                                                        </label>

                                                        <select
                                                            defaultValue={
                                                                data.seating_profile_id
                                                                    ? data.seating_profile_id
                                                                    : ''
                                                            }
                                                            name={data.value}
                                                            onChange={handleTimeSeatingArrChange}
                                                            className="w-full h-[42px] px-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                                        >
                                                            <option value="">
                                                                Select seating
                                                            </option>

                                                            {seatingProfiles.data.map(profile => (
                                                                <option
                                                                    key={profile.id}
                                                                    value={profile.id}
                                                                >
                                                                    {profile.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* VEHICLE */}
                                                    {isSuccessUserVerhicles && (
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
                                                                Vehicle
                                                            </label>

                                                            <select
                                                                defaultValue={
                                                                    data.vehicle_id
                                                                        ? data.vehicle_id
                                                                        : 0
                                                                }
                                                                name={data.value}
                                                                onChange={handleTimeVerhicleChange}
                                                                className="w-full h-[42px] px-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-white outline-none focus:border-[#80b643] focus:ring-1 focus:ring-[#80b643]"
                                                            >
                                                                <option value={0}>
                                                                    Select vehicle
                                                                </option>

                                                                {userVehicles?.data?.map(vehicle => (
                                                                    <option
                                                                        key={vehicle.value}
                                                                        value={vehicle.value}
                                                                    >
                                                                        {vehicle.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="flex justify-end mt-5 pt-4 border-t border-gray-200 dark:border-gray-800">
                                        <button
                                            type="button"
                                            onClick={editTime}
                                            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm font-medium text-gray-600 dark:text-gray-300 hover:border-[#80b643] hover:text-[#80b643] transition"
                                        >
                                            <PencilIcon className="w-4 h-4" />
                                            Edit Schedule
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* EDITABLE PRICE */}
                            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">
                                <div className="px-4 sm:px-5 py-4">
                                    <div className="flex items-center justify-between gap-4">
                                        <div className="flex items-center gap-3">
                                            <div className="w-9 h-9 rounded-lg bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                                                <CurrencyDollarIcon className="w-5 h-5 text-[#80b643]" />
                                            </div>

                                            <div>
                                                <h2 className="text-sm font-semibold text-gray-800 dark:text-white">
                                                    Selling Price
                                                </h2>

                                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                    Allow employees to change the ticket price
                                                </p>
                                            </div>
                                        </div>

                                        <label className="relative inline-flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                name="editable_price"
                                                value={input.editable_price}
                                                checked={!!input.editable_price}
                                                onChange={handleToggleEditablePrice}
                                                className="sr-only peer"
                                            />

                                            <div className="w-11 h-6 bg-gray-200 dark:bg-gray-700 rounded-full peer peer-focus:ring-2 peer-focus:ring-[#80b643]/30 peer-checked:bg-[#80b643] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-white"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* TAXES */}
                            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">
                                <div className="px-4 sm:px-5 py-4 border-b border-gray-200 dark:border-gray-800">
                                    <div className="flex items-center gap-2">
                                        <ReceiptTaxIcon className="w-5 h-5 text-[#80b643]" />

                                        <div>
                                            <h2 className="text-sm sm:text-base font-semibold text-gray-800 dark:text-white">
                                                Taxes
                                            </h2>

                                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                Select taxes that should apply to tickets on this route
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-4 sm:p-5">
                                    {isSuccessTaxes ? (
                                        taxes.data.length > 0 ? (
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                {taxes.data.map(data => (
                                                    <label
                                                        key={data.id}
                                                        className="flex items-center justify-between gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/70 dark:bg-gray-800/50 cursor-pointer hover:border-[#80b643]/50 transition"
                                                    >
                                                        <div className="flex items-center gap-3">
                                                            <div className="w-8 h-8 rounded-lg bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                                                                <ReceiptTaxIcon className="w-4 h-4 text-[#80b643]" />
                                                            </div>

                                                            <div>
                                                                <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
                                                                    {data.name}
                                                                </p>

                                                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                                                    {data.rate}%
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <input
                                                            type="checkbox"
                                                            name="taxes[]"
                                                            value={data.id}
                                                            checked={
                                                                taxesInput.route_tax
                                                                    ? taxesInput.route_tax.includes(data.id)
                                                                    : false
                                                            }
                                                            onChange={e =>
                                                                handleTaxes(
                                                                    e,
                                                                    data.id
                                                                )
                                                            }
                                                            className="w-4 h-4 rounded border-gray-300 text-[#80b643] focus:ring-[#80b643]"
                                                        />
                                                    </label>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="text-center py-8">
                                                <div className="w-12 h-12 rounded-xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center mx-auto">
                                                    <ReceiptTaxIcon className="w-6 h-6 text-gray-400" />
                                                </div>

                                                <p className="mt-3 text-sm font-medium text-gray-600 dark:text-gray-300">
                                                    No taxes found
                                                </p>

                                                <p className="text-xs text-gray-400 mt-1">
                                                    No tax configuration is available for this account.
                                                </p>
                                            </div>
                                        )
                                    ) : (
                                        <div className="flex items-center justify-center py-8">
                                            <div className="w-7 h-7 border-2 border-gray-200 border-t-[#80b643] rounded-full animate-spin"></div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* STATUS */}
                            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden mb-5">
                                <div className="px-4 sm:px-5 py-4">
                                    <div className="flex items-center justify-between gap-4">
                                        <div className="flex items-center gap-3">
                                            <div className="w-9 h-9 rounded-lg bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                                                <CheckCircleIcon className="w-5 h-5 text-[#80b643]" />
                                            </div>

                                            <div>
                                                <h2 className="text-sm font-semibold text-gray-800 dark:text-white">
                                                    Route Status
                                                </h2>

                                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                    Enable or disable this route for ticket sales
                                                </p>
                                            </div>
                                        </div>

                                        <label className="relative inline-flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                name="status"
                                                value={input.status}
                                                checked={!!input.status}
                                                onChange={handleStatusChange}
                                                className="sr-only peer"
                                            />

                                            <div className="w-11 h-6 bg-gray-200 dark:bg-gray-700 rounded-full peer peer-focus:ring-2 peer-focus:ring-[#80b643]/30 peer-checked:bg-[#80b643] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-white"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* SAVE ACTIONS */}
                            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden">
                                <div className="p-4 sm:p-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
                                    <button
                                        type="button"
                                        onClick={back}
                                        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#80b643] hover:bg-[#719f3a] text-white text-sm font-medium shadow-sm transition"
                                    >
                                        <SaveIcon className="w-4 h-4" />
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default RouteEditView;